import includes from 'lodash/includes';
import {getWindow} from 'ssr-window';
import EnvironmentUtils from '@spothero/utils/environment';

const window = getWindow();

export const SearchGeocoderUtils = gmaps => ({
    _geocoder: gmaps ? new gmaps.Geocoder() : null,

    getAddressData(geocodeData) {
        const {
            address_components: addressComponents,
            formatted_address: formattedAddress,
            geometry,
            id,
            place_id: placeId,
            reference,
        } = geocodeData;
        const data = {
            search_string: formattedAddress, // eslint-disable-line camelcase
            latitude: geometry ? geometry.location.lat() : null,
            longitude: geometry ? geometry.location.lng() : null,
            places_id: id, // eslint-disable-line camelcase
            places_place_id: placeId, // eslint-disable-line camelcase
            places_reference: reference, // eslint-disable-line camelcase
        };

        if (addressComponents) {
            addressComponents.forEach(item => {
                if (includes(item.types, 'street_number')) {
                    if (!('street' in data)) {
                        data.street = item.long_name;
                    } else {
                        data.street = `${item.long_name} ${data.street}`;
                    }
                } else if (includes(item.types, 'route')) {
                    if (!('street' in data)) {
                        data.street = item.long_name;
                    } else {
                        data.street = `${data.street} ${item.long_name}`;
                    }
                } else if (includes(item.types, 'locality')) {
                    data.city = item.long_name;
                } else if (
                    includes(item.types, 'administrative_area_level_1')
                ) {
                    data.state = item.short_name;
                } else if (includes(item.types, 'postal_code')) {
                    data.zipCode = item.long_name;
                }
            });
        }

        return data;
    },
});

export default SearchGeocoderUtils(
    EnvironmentUtils.isBrowser() ? window.google.maps : null
);
